module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 261
// module chunks = 0